import React from "react";
import { ErrorBandaid } from "../../assets/images";
import styles from "./ErrorLayout.module.scss";
export type ErrorLayoutPropsType = {
  header: string;
  subheader: string;
};

export const ErrorLayout: React.FC<ErrorLayoutPropsType> = props => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.imageContainer}>
        <ErrorBandaid />
      </div>
      <p className={styles.header}>{props.header}</p>
      <p className={styles.subheader}>{props.subheader}</p>
    </div>
  );
};
